export const machines = [
  {
    id: 1,
    name: "AJAX FIORI ARGO 4000",
    description:
      "The AJAX FIORI ARGO 4000 is a self-loading concrete mixer that ensures efficient mixing and transport.",
    price: "2,00,000/ Month",
    image: "/Images/cart_machine_item/b2-1-300x300.jpg",
  },
  {
    id: 2,
    name: "WATER TANKER 20 KL",
    description:
      "The Water Tanker 20 KL is a durable vehicle for efficient large-scale water transport. Its large capacity ensures long operation between refills.",
    price: "75,000/ Month",
    image: "/Images/cart_machine_item/product-jpeg-500x500-1-300x225.png",
  },
  {
    id: 3,
    name: "WATER TANKER 12 KL",
    description:
      "Efficiently transports up to 20,000 liters of water. Perfect for construction, irrigation, and industrial use.",
    price: "60,000/ Month",
    image: "/Images/cart_machine_item/product-jpeg-500x500-1-300x300.jpg",
  },
  {
    id: 4,
    name: "GRADER",
    description:
      "Precision equipment for leveling and grading surfaces. Ideal for roadwork, construction, and land preparation.",
    price: "3,10,000/ Month",
    image: "/Images/cart_machine_item/Gemini_Generated_Image_vyv5oovyv5oovyv5-300x300.jpeg",
  },
  {
    id: 5,
    name: "TRANSIT MIXER",
    description:
      "Mixes and transports concrete efficiently. Ideal for construction projects requiring ready-mixed concrete on-site.",
    price: "1,30,000/ Month",
    image: "/Images/cart_machine_item/Gemini_Generated_Image_d7cucnd7cucnd7cu-300x300.jpeg",
  },
  {
    id: 6,
    name: "TRACTOR GRADER",
    description:
      "Versatile machine for grading and leveling surfaces. Perfect for road maintenance, construction, and land shaping.",
    price: " 1,50,000/ Month",
    image: "/Images/cart_machine_item/WhatsApp-Image-2024-09-14-at-11.34.04_0fcf96a9-1-300x300.jpg",
  },
  {
    id: 7,
    name: "SOIL COMPECTOR",
    description:
      "Compacts soil for stable, firm surfaces. Essential for construction and roadwork to ensure proper ground density and stability.",
    price: " 1,20,000/ Month",
    image: "/Images/cart_machine_item/3-1-300x300.jpg",
  },
  {
    id: 8,
    name: "TIPPER",
    description:
      "Efficiently transports and unloads materials like gravel, sand, or soil. Ideal for construction and excavation projects.",
    price: "1,40,000/ Month",
    image: "/Images/cart_machine_item/Gemini_Generated_Image_oko412oko412oko4-300x300.jpeg",
  },
  {
    id: 9,
    name: "HYDRA",
    description:
      "Versatile crane for lifting and moving heavy materials. Ideal for construction, excavation, and material handling tasks.",
    price: " 65,000/ Month",
    image: "/Images/cart_machine_item/Gemini_Generated_Image_o9i2r7o9i2r7o9i2-300x300.jpeg",
  },
  {
    id: 10,
    name: "DCM",
    description:
      "Heavy-duty transporter vehicle for moving equipment and materials. Ideal for construction sites and large-scale projects.",
    price: " 65,000/ Month",
    image: "/Images/cart_machine_item/small_Tata_1812g_LPT_435804f6cf-1-300x300.jpg",
  },
  {
    id: 11,
    name: "BOLERO CAMPER",
    description:
      "Compact, rugged vehicle for transporting personnel and equipment. Ideal for off-road and remote site access.",
    price: " 34,000/ Month",
    image: "/Images/cart_machine_item/front-left-side-47-1-300x300.jpg",
  },
  {
    id: 12,
    name: "BOLERO",
    description:
      "Reliable and durable utility vehicle. Perfect for transporting personnel and cargo in various terrains.",
    price: " 32,000/ Month",
    image: "/Images/cart_machine_item/mahindra_bolero_three_0-1-300x300.jpg",
  },
  {
    id: 13,
    name: "PICKUP",
    description:
      "Versatile vehicle for transporting goods and equipment. Ideal for both urban and rugged terrains.",
    price: " 34,000/ Month",
    image: "/Images/cart_machine_item/mahindra-bolero-maxx-pick-up-300x300.jpg",
  },
  {
    id: 14,
    name: "TATA ACE(CHOTA HATHI)",
    description:
      "Compact and nimble truck for transporting goods. Ideal for urban deliveries and small-scale logistics.",
    price: " 30,000/ Month",
    image: "/Images/cart_machine_item/pickup-transport-service-300x300.jpg",
  },
  {
    id: 15,
    name: "TRACTOR TANKER",
    description:
      "Combines a tractor with a large tanker for efficient water or liquid transport. Perfect for agricultural, construction, and industrial uses.",
    price: " 30,000/ Month",
    image: "/Images/cart_machine_item/WhatsApp-Image-2024-09-14-at-12.10.22_6caab740-1-300x300.jpg",
  },
  {
    id: 16,
    name: "TRACTOR TROLLY",
    description:
      "Durable attachment for transporting goods and materials. Ideal for farming, construction, and heavy-duty hauling.",
    price: "28,000/ Month",
    image: "/Images/cart_machine_item/Gemini_Generated_Image_2ry9652ry9652ry9-300x300.jpeg",
  },
  {
    id: 17,
    name: "MAHINDRA SCORPIO",
    description:
      "Rugged SUV offering reliable off-road capability and ample space. Ideal for tough terrains and long journeys.",
    price: " 32,000/ Month",
    image: "/Images/cart_machine_item/Gemini_Generated_Image_4zow8j4zow8j4zow-300x300.jpeg",
  },
  {
    id: 18,
    name: "TRAILER",
    description:
      "Versatile unit for hauling large loads and equipment. Ideal for transportation across various terrains and applications.",
    price: " 1,10,000/ Month",
    image: "/Images/cart_machine_item/tata-lps-4018-truck-tractors-gcw-40200-kg-2-300x300.jpg",
  },
  {
    id: 19,
    name: "JCB Backhoe Loader",
    description:
      "Durable attachment for transporting goods and materials. Ideal for farming, construction, and heavy-duty hauling.",
    price: " 90,000/ Month",
    image: "/Images/cart_machine_item/jcb_3dx_backhoe_loader1686911730_2b5e36e8a3-1-1-1-300x300.jpg",
  },
];